import { Loader2, LogIn, RefreshCw, WifiOff } from "lucide-react";
import { Button } from "@/components/ui/button";
import { registrarAviso, tentarERegistrar, useRegistroDoAviso } from "@/lib/avisoConexao";

// Lista que FALHOU não é lista vazia (Pedro, 23/10/2026: com a rede caindo, Produtos dizia «Nenhum produto cadastrado»
// e a lojista achou que os 21 produtos tinham sumido). Aviso pequeno no lugar da lista. Sessão que caiu (401) pede para
// entrar de novo, porque tentar de novo não resolve; o Pedidos tem a versão grande disso desde 19/09.
// `tela` vai no registro do aviso ([aviso-conexao] no client_errors). `onTentar` devolve o refetch (ou vários).
export function FalhaAoCarregar({ tela, erro, onTentar, tentando }: { tela: string; erro: unknown; onTentar: () => unknown; tentando: boolean }) {
  const semSessao = (erro as { status?: number } | null)?.status === 401;
  useRegistroDoAviso(tela, erro);
  return (
    <div
      role="alert"
      className="flex items-center gap-3 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-900 dark:border-amber-900 dark:bg-amber-950/30 dark:text-amber-200"
      data-testid="falha-ao-carregar"
    >
      {semSessao ? <LogIn className="w-4 h-4 shrink-0" /> : <WifiOff className="w-4 h-4 shrink-0" />}
      <span className="flex-1 min-w-0">
        {semSessao ? "Sua sessão expirou. Entre de novo." : "Sem conexão com o servidor. Confira sua internet."}
      </span>
      {semSessao ? (
        <Button size="sm" variant="outline" className="shrink-0" onClick={() => { registrarAviso(`entrar tela=${tela}`, true); window.location.href = `${import.meta.env.BASE_URL.replace(/\/$/, "")}/login`; }}>
          Entrar
        </Button>
      ) : (
        <Button size="sm" variant="outline" className="shrink-0" onClick={() => void tentarERegistrar(tela, erro, onTentar)} disabled={tentando} data-testid="falha-ao-carregar-tentar">
          {tentando ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <RefreshCw className="w-4 h-4 mr-1" />}
          Tentar de novo
        </Button>
      )}
    </div>
  );
}
